import React from 'react';
import Skeleton from 'react-loading-skeleton';

const SKELETON_COUNT = 3;

export const BroadcasterSkeleton = () => {
    return (
        <div
            className="broadcast-guide__broadcaster-list"
            style={{ justifyContent: 'center' }}
        >
            {(() => {
                const skeletons = [];

                for (let i = 0; i < SKELETON_COUNT; i++) {
                    skeletons.push(
                        <div
                            key={i}
                            className="broadcast-guide__broadcaster-skeleton"
                        >
                            <p className="broadcast-guide__broadcaster-type">
                                <Skeleton width={80} />
                            </p>
                            <Skeleton height={72} />
                            <p className="broadcast-guide__broadcaster-channel-name">
                                <Skeleton width={80} />
                            </p>
                        </div>
                    );
                }

                return skeletons;
            })()}
        </div>
    );
};
